import { autoinject, computedFrom } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssTabsHorizontalPage extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 2 ********************************************////
    protected displayTabs: Record<string, boolean> = {};

    protected displayTabContents(tabId: string): void {
        this.displayTabs[tabId] = true;
    }

    ////****************** Example 3 ********************************************////
    protected ex3NumTabs: number = 5;
    protected ex3ActiveTab: number = 3;

    @computedFrom('ex3NumTabs')
    protected get ex3Tabs(): number[] {
        return Array.from({ length: this.ex3NumTabs }, (e, i) => i + 1);
    }

}
